<template>

  <v-card class='mx-auto' width='100%'>
    <v-row no-gutters>
      <v-col>
        <v-card flat tile class='mt-10'>
          <v-row no-gutters>
            <v-col class='d-flex mb-1' >
              <v-btn class='mx-2' color='secondary' small @click="refreshBundle"><v-icon>{{mdiRefresh}}</v-icon>{{$t("label.refresh")}}</v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-tabs background-color='#009964' center-active dark  v-model="tab">
            <v-tab key="bundleTab1" @click="searchBundle('PROCESSING')">{{ $t("label.processing")}}</v-tab>
            <v-tab key="bundleTab2" @click="searchBundle('READY')">{{ $t("label.ready_for_delivery")}}</v-tab>
            <v-tab key="bundleTab3" @click="searchBundle('DELIVERED')">{{ $t("label.delivered")}}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
              <v-tab-item key="bundleTab1">
                <v-card flat >
                  <v-data-table :headers="processingHeaders" :items="processingBundles" :items-per-page="10" item-key="BundleNo"
                    :server-items-length="totalProcessingBundles"  :page="processingBundlePage" :options.sync="processingBundleOptions"
                    :loading="loadingBundles"
                    class="elevation-1" :single-expand="true" show-expand >

                    <template v-slot:expanded-item="{ headers, item }" >
                      <td :colspan="headers.length" class='mx-0 px-0'>
                        <v-data-table :headers="orderViewHeaders" :items="item.OrderViews" dense hide-default-footer
                          class="elevation-4">
                        </v-data-table>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item key="bundleTab2">
                <v-card flat>
                  <v-data-table  :headers="readyHeaders" :items="readyBundles" :items-per-page="10" item-key="BundleNo"
                    :server-items-length="totalReadyBundles"  :page="readyBundlePage" :options.sync="readyBundleOptions"
                    :loading="loadingBundles"
                  class="elevation-1" :single-expand="true" show-expand >

                    <template v-slot:expanded-item="{ headers, item }" >
                      <td :colspan="headers.length" class='mx-0 px-0' >
                        <v-data-table :headers="orderViewHeaders" :items="item.OrderViews" dense  hide-default-footer
                          class="elevation-4">
                        </v-data-table>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item key="bundleTab3">
                <v-card flat>
                  <v-data-table :headers="deliveredHeaders" :items="deliveredBundles" :items-per-page="10" item-key="BundleNo"
                  :server-items-length="totalDeliveredBundles"  :page="deliveredBundlePage" :options.sync="deliveredBundleOptions"
                  :loading="loadingBundles"
                   class="elevation-1" :single-expand="true" show-expand >

                    <template v-slot:expanded-item="{ headers, item }" >
                      <td :colspan="headers.length" class='mx-0 px-0' >
                        <v-data-table :headers="orderViewHeaders" :items="item.OrderViews" dense hide-default-footer
                          class="elevation-4">
                        </v-data-table>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor">
    {{ text }}
    <v-btn icon @click="snackbar = false">
      <v-icon>{{mdiClose}}</v-icon>
    </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mdiRefresh, mdiClose } from '@mdi/js'
import i18n from '../lang/lang';
import { SearchBundle  } from "@/api/publicServices";

export default {
    data: () => ({
      tab: null,
      stepTitle1: "",
      stepTitle2: "",
      stepTitle3: "",
      title: 'label.bundle',
      snackbar: false,
      snackbarColor: "secondary",
      timeout: 10000,
      text: '',
      processingBundles: [],
      readyBundles: [],
      deliveredBundles: [],
      processingBundlePageSize: 10,
      processingBundlePage: 1,
      processingBundleOptions: {},
      totalProcessingBundles: 0,
      readyBundlePageSize: 10,
      readyBundlePage: 1,
      readyBundleOptions: {},
      totalReadyBundles: 0,
      deliveredBundlePageSize: 10,
      deliveredBundlePage: 1,
      deliveredBundleOptions: {},
      totalDeliveredBundles: 0,
      loadingBundles: false,

      // svg icons
      mdiRefresh,
      mdiClose,
    }),
    components: {
    },
    methods: {
      refreshBundle() {
        if (this.tab == 0) {
          this.searchBundle('PROCESSING');
        } else if (this.tab == 1) {
          this.searchBundle('READY');
        }  else if (this.tab == 2) {
          this.searchBundle('DELIVERED');
        }
      },
      async searchBundle(status) {
        try {
          let data = {};
          data.Status = status;
          this.loadingBundles = true
          if (status == 'PROCESSING') {
            data.PageSize = this.processingBundlePageSize;
            data.PageNum = this.processingBundleOptions.page;
          } else if (status == 'READY') {
            data.PageSize = this.readyBundlePageSize;
            data.PageNum = this.readyBundleOptions.page;
          } else if (status == 'DELIVERED') {
            data.PageSize = this.deliveredBundlePageSize;
            data.PageNum = this.deliveredBundleOptions.page;
          }

          const response = await SearchBundle(data);


          if (status == 'PROCESSING') {
            this.processingBundles = response.data.Results;
            this.totalProcessingBundles = response.data.Total;
          } else if (status == 'READY') {
            this.readyBundles = response.data.Results;
            this.totalReadyBundles = response.data.Total;
          }  else if (status == 'DELIVERED') {
            this.deliveredBundles = response.data.Results;
            this.totalDeliveredBundles = response.data.Total;
          }
          this.loadingBundles = false;

        } catch (error) {
            console.log(error);
        }
      },
      resetBundling() {
        this.stepTitle1 = i18n.t('label.processing');
        this.stepTitle2 = i18n.t('label.ready');
        this.stepTitle3 = i18n.t('label.delivered');
      },
    },
    computed: {
      processingHeaders () {
        return [
        { text: i18n.t("label.bundle_no"), value: 'BundleNo' },
        { text: i18n.t("label.no_of_label"), value: 'OrderViews.length' },
        { text: i18n.t("label.package"), value: 'Pkg' },
        { text: i18n.t("label.weight"), value: 'Wgt'  },
        { text: i18n.t("label.issue_date"), value: 'IssueDate' }
        ]
      },
      readyHeaders() {
        return [
          { text: i18n.t("label.bundle_no"), value: 'BundleNo' },
          { text: i18n.t("label.no_of_label"), value: 'OrderViews.length' },
          { text: i18n.t("label.package"), value: 'Pkg' },
          { text: i18n.t("label.weight"), value: 'Wgt'  },
          { text: i18n.t("label.issue_date"), value: 'IssueDate' }
        ]

      },
      deliveredHeaders() {
        return [
          { text: i18n.t("label.bundle_no"), value: 'BundleNo' },
          { text: i18n.t("label.no_of_label"), value: 'OrderViews.length' },
          { text: i18n.t("label.package"), value: 'Pkg' },
          { text: i18n.t("label.weight"), value: 'Wgt'  },
          { text: i18n.t("label.issue_date"), value: 'IssueDate' }
        ];
      },
      orderViewHeaders() {
        return [
          { text: i18n.t("label.order_no"), value: 'OrderNo' },
          { text: i18n.t("label.product_name"), value: 'ProductName' },
          { text: i18n.t("label.courier_no"), value: 'CourierNo' },
          { text: i18n.t("label.package"), value: 'Pkg' },
          { text: i18n.t("label.weight"), value: 'Wgt' }

        ];
      }
    },
    mounted () {
      this.processingBundleOptions.page = 1;
      this.readyBundleOptions.page = 1;
      this.deliveredBundleOptions.page = 1;
      this.searchBundle('PROCESSING');
    },
    watch: {
      processingBundleOptions: {
        handler () {
          this.searchBundle('PROCESSING');
        },
        deep: true,
      },
      readyBundleOptions: {
        handler () {
          this.searchBundle('READY');
        },
        deep: true,
      },
      deliveredBundleOptions: {
        handler () {
          this.searchBundle('DELIVERED');
        },
        deep: true,
      },
    },
  };

</script>
